import { Instagram, Youtube, Twitch, Link as LinkIcon, Facebook, Twitter, Music2, Globe } from "lucide-react";

export const PLATFORMS = [
  "Instagram",
  "TikTok",
  "X",
  "YouTube",
  "Twitch",
  "Facebook",
  "Linktree",
  "Other",
];

export function PlatformIcon({ platform, className = "w-5 h-5" }) {
  const map = {
    Instagram: <Instagram className={className} />,
    TikTok: <Music2 className={className} />,
    X: <Twitter className={className} />,
    YouTube: <Youtube className={className} />,
    Twitch: <Twitch className={className} />,
    Facebook: <Facebook className={className} />,
    Linktree: <LinkIcon className={className} />,
    Other: <Globe className={className} />,
  };
  return map[platform] || map.Other;
}

export const PLATFORM_COLORS = {
  Instagram: "#E1306C",
  TikTok: "#00F2EA",
  X: "#FFFFFF",
  YouTube: "#FF0033",
  Twitch: "#9146FF",
  Facebook: "#1877F2",
  Linktree: "#39E09B",
  Other: "#00F0FF",
};
